module.exports = __webpack_public_path__ + "static/media/IH01_nomadd.6e0fd2b3.jpg";